import React, { useEffect, useState } from 'react';
import { HintWrapper } from './homebrewhint.style';
import { trackBrewCopy } from '../../../common/analytics';

const BREW_COMMAND = 'brew install cloudpouch';

// Shown only to macOS visitors (SSR renders nothing, so no flash on other OSes).
const HomebrewHint = () => {
  const [isMac, setIsMac] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && navigator.userAgent.includes('Macintosh')) {
      setIsMac(true);
    }
  }, []);

  const handleCopy = () => {
    trackBrewCopy();
    navigator.clipboard
      .writeText(BREW_COMMAND)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {});
  };

  if (!isMac) return null;

  return (
    <HintWrapper>
      <span className="hint-label">Or install with Homebrew:</span>
      <code>
        <span aria-hidden="true">$ </span>
        {BREW_COMMAND}
      </code>
      <button
        type="button"
        onClick={handleCopy}
        aria-label="Copy Homebrew install command"
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </HintWrapper>
  );
};

export default HomebrewHint;
